import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import "../Tables/Table.css";
import {
  deleteHL7Node,
  updateCurrentStatusHl7config,
} from "../utilities/HL7utils";

export default function HL7NodeTable(props) {
  const {
    searchInput,
    searchflag,
    setsearchflag,
    sortby,
    hL7Configs,
    deleteAlert,
    setDeleteAlert,
    handlePage,
    setDeleteID,
    type,
    setEdit,
    setEditModal,
    setFlag,
    currentPage,
  } = props;
  const [count, setCount] = useState(1);
  const [configData, setConfigData] = useState([]);
  const [numberOfEntries, setNumberOfEntries] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [currentIdToDelete, setCurrentIdToDelete] = useState(-1);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (searchflag) {
      setCount(1);
      setsearchflag(false);
    }
  }, [searchflag, searchInput, setsearchflag]);

  useEffect(() => {
    if (hL7Configs && hL7Configs.items) {
      setConfigData(hL7Configs.items);
      setTotalData(hL7Configs.total);
      setTotalPages(Math.ceil(hL7Configs.total / numberOfEntries));
    }
  }, [hL7Configs, numberOfEntries]);

  const handleDelete = (id) => {
    setDeleteAlert(true);
    setDeleteID(id);
    setIsDeleteModalOpen(true);
  };

  const handleActiveStatus = async (id, e) => {
    try {
      const response = await updateCurrentStatusHl7config({
        id: id,
        toggle: e.target.checked,
      });

      if (response.success === true) {
        toast.success(`Error: ${response.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });

        setFlag((state) => !state);
      } else {
        toast.error(`Error: ${response.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setFlag((state) => !state);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const handleConfirmDelete = () => {
    deleteHL7Node(currentIdToDelete);
    setIsDeleteModalOpen(false);
  };

  const handleEdit = (item) => {
    setEdit(item);
    setEditModal(true);
  };

  const handlePageChange = (page) => {
    if (page >= 0 && page < totalPages) {
      setCount(page + 1);
    }
  };

  const renderActions = (item) => (
    <div>
      <i
        className="fa fa-trash"
        onClick={() => handleDelete(item?.id)}
        style={{
          cursor: "pointer",
          marginRight: "1rem",
          fontSize: "1rem",
          color: "white",
        }}
        title="Delete"
      ></i>
      <i
        className="fa fa-pencil"
        onClick={() => handleEdit(item)}
        style={{ cursor: "pointer", fontSize: "1rem", color: "white" }}
        title="Edit"
      ></i>
    </div>
  );

  return (
    <>
      <div style={{ width: "92vw", overflow: "auto" }}>
        <table className="hl7-table styled-table-node">
          <thead>
            <tr>
              <th>Name</th>
              <th>Filters</th>
              <th>Operations</th>
              <th>Push Back Nodes</th>
              <th>Received From</th>
              <th>Router Config</th>
              <th>Segments</th>
              <th>Unique Identifier</th>
              {/* <th>Actions</th> */}
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            {configData &&
              configData.map((item) => (
                <tr key={item.id}>
                  <td>{item.config_name}</td>
                  <td style={{ verticalAlign: "Baseline" }}>
                    {item.filters && item.filters.length > 0 && (
                      <table>
                        <thead>
                          <tr>
                            <th>TAG ID</th>
                            <th>Values</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.filters &&
                            item.filters.map((ele) => (
                              <tr key={ele.id}>
                                <td>{ele.tag_id}</td>
                                <td>{ele.value.toString()}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </td>
                  <td>{item.operation}</td>
                  <td style={{ verticalAlign: "Baseline" }}>
                    {item.push_back_nodes &&
                      item.push_back_nodes.length > 0 && (
                        <table>
                          <thead>
                            <tr>
                              <th>Operation Name</th>
                              <th>Node</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.push_back_nodes &&
                              item.push_back_nodes.map((ele) => (
                                <tr key={ele.id}>
                                  <td>{ele.operation_name}</td>
                                  <td>{ele.node}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      )}
                  </td>
                  <td>{item.receive_from}</td>
                  <td>{item.router_configuration}</td>
                  <td style={{ verticalAlign: "Baseline" }}>
                    {item.segments && item.segments.length > 0 && (
                      <table>
                        <thead>
                          <tr>
                            <th>Segment Name</th>
                            <th>Field Number</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.segments &&
                            item.segments.map((ele) => (
                              <tr key={ele.id}>
                                <td>{ele.segment_name}</td>
                                <td>{ele.field_number}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </td>
                  <td>{item.unique_identifier_type}</td>
                  {/* <td>{renderActions(item)} </td> */}
                  <td>
                    <input
                      type="checkbox"
                      checked={item.active}
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        handleActiveStatus(item.id, e);
                      }}
                    />{" "}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="pagination">
          <ReactPaginate
            previousLabel="<"
            nextLabel=">"
            breakLabel="..."
            breakClassName="break-me"
            pageCount={totalPages && totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            forcePage={currentPage && currentPage} //{entityList.number}
            onPageChange={(e) => handlePage(e.selected)}
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
            previousLinkClassName="pagination-link"
            nextLinkClassName="pagination-link"
            breakLinkClassName="pagination-link"
            pageLinkClassName="pagination-link"
          />
        </div>
      </div>
    </>
  );
}
